import dashboardActionConstants from '../constants/dashboardActionConstants';

const initialState = {
  selectedOrganization: { name: 'Dashboard' },
  activityList: [],
  activityListLoading: false,
  isLastActivityPage: false,
  leaderBoardList: [],
  leaderBoardListLoading: false,
  termsAndConditions: {},
  termsAndConditionsLoading: false,
  hotJobs: [],
  recommendedJobs: [],
  recommendedJobsLoading: false,
  hotJobsLoading: false,
  referralRecommendations: [],
  referralRecommendationsLoading: false,
  referralRecommendationsTotal: 0,
  referralLink: '',
  referralLinkLoading: false,
};

const activityReducer = (state = initialState, action) => {
  let activityList = [];
  let likedObjectIndex = null;

  switch (action.type) {
    case dashboardActionConstants.CHANGE_SELECTED_ORGANIZATION_HOME:
      return {
        ...state,
        selectedOrganization: action.payload,
      };
    case dashboardActionConstants.GET_ACTIVITY_LIST:
      return {
        ...state,
        activityListLoading: !action.payload.isPagination,
        activityList: action.payload.isPagination ? state.activityList : [],
      };
    case dashboardActionConstants.GET_ACTIVITY_LIST_SUCCESS:
      activityList = action.payload.isPagination
        ? state.activityList.concat(action.payload.activities)
        : action.payload.activities;

      activityList = activityList.map((activity) => {
        if (activity.matching_users && activity.matching_users.length !== 0) {
          return {
            ...activity,
            matching_users: activity.matching_users.map((matching_user) => ({
              ...matching_user,
              job: activity.job,
              organization: activity.organization,
            })),
          };
        }
        return activity;
      });
      return {
        ...state,
        activityList,
        isLastActivityPage: action.payload.activities.length < 10,
        activityListLoading: false,
      };
    case dashboardActionConstants.GET_ACTIVITY_LIST_ERROR:
      return {
        ...state,
        activityListLoading: false,
      };
    case dashboardActionConstants.GET_LEADER_BOARD_LIST:
      return {
        ...state,
        leaderBoardList: [],
        leaderBoardListLoading: true,
      };
    case dashboardActionConstants.GET_LEADER_BOARD_LIST_SUCCESS:
      return {
        ...state,
        leaderBoardList: action.payload.records,
        leaderBoardListLoading: false,
      };
    case dashboardActionConstants.GET_LEADER_BOARD_LIST_ERROR:
      return {
        ...state,
        leaderBoardListLoading: false,
      };
    case dashboardActionConstants.LIKE_ACTIVITY:
      activityList = state.activityList.slice();
      likedObjectIndex = activityList.findIndex((activity) => activity.id === action.payload);
      activityList[likedObjectIndex].liked = true;
      activityList[likedObjectIndex].likes += 1;

      return {
        ...state,
        activityList,
      };
    case dashboardActionConstants.LIKE_ACTIVITY_ERROR:
      activityList = state.activityList.slice();
      likedObjectIndex = activityList.findIndex((activity) => activity.id === action.payload);
      activityList[likedObjectIndex].liked = false;
      activityList[likedObjectIndex].likes -= 1;

      return {
        ...state,
        activityList,
      };
    case dashboardActionConstants.UNLIKE_ACTIVITY:
      activityList = state.activityList.slice();
      likedObjectIndex = activityList.findIndex((activity) => activity.id === action.payload);
      activityList[likedObjectIndex].liked = false;
      activityList[likedObjectIndex].likes -= 1;

      return {
        ...state,
        activityList,
      };
    case dashboardActionConstants.UNLIKE_ACTIVITY_ERROR:
      activityList = state.activityList.slice();
      likedObjectIndex = activityList.findIndex((activity) => activity.id === action.payload);
      activityList[likedObjectIndex].liked = true;
      activityList[likedObjectIndex].likes += 1;

      return {
        ...state,
        activityList,
      };
    case dashboardActionConstants.GET_REWARDS_TERMS_AND_CONDITIONS:
      return {
        ...state,
        termsAndConditions: {},
        termsAndConditionsLoading: true,
      };
    case dashboardActionConstants.GET_REWARDS_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        termsAndConditions: action.payload,
        termsAndConditionsLoading: false,
      };
    case dashboardActionConstants.GET_REWARDS_TERMS_AND_CONDITIONS_ERROR:
      return {
        ...state,
        termsAndConditionsLoading: false,
      };
    case dashboardActionConstants.GET_HOT_JOBS:
      return {
        ...state,
        hotJobsLoading: true,
      };
    case dashboardActionConstants.GET_HOT_JOBS_SUCCESS:
      return {
        ...state,
        hotJobs: action.payload,
        hotJobsLoading: false,
      };
    case dashboardActionConstants.GET_HOT_JOBS_ERROR:
      return {
        ...state,
        hotJobsLoading: false,
      };
    case dashboardActionConstants.GET_RECOMMENDED_JOBS:
      return {
        ...state,
        recommendedJobsLoading: true,
      };
    case dashboardActionConstants.GET_RECOMMENDED_JOBS_SUCCESS:
      return {
        ...state,
        recommendedJobs: action.payload,
        recommendedJobsLoading: false,
      };
    case dashboardActionConstants.GET_RECOMMENDED_JOBS_ERROR:
      return {
        ...state,
        recommendedJobsLoading: false,
      };
    case dashboardActionConstants.GET_REFERRAL_RECOMMENDATIONS:
      return {
        ...state,
        referralRecommendationsLoading: true,
        referralRecommendationsTotal: 0,
      };
    case dashboardActionConstants.GET_REFERRAL_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        referralRecommendations: action.payload.recommendations,
        referralRecommendationsTotal: action.payload.total_count,
        referralRecommendationsLoading: false,
      };
    case dashboardActionConstants.GET_REFERRAL_RECOMMENDATIONS_ERROR:
      return {
        ...state,
        referralRecommendationsLoading: false,
      };
    case dashboardActionConstants.GET_REFERRAL_LINK:
      return {
        ...state,
        referralLinkLoading: true,
      };
    case dashboardActionConstants.GET_REFERRAL_LINK_SUCCESS:
      return {
        ...state,
        referralLink: action.payload,
        referralLinkLoading: false,
      };
    case dashboardActionConstants.GET_REFERRAL_LINK_ERROR:
      return {
        ...state,
        referralLinkLoading: false,
      };

    default:
      return state;
  }
};

export default activityReducer;
